import axios from "axios"

export default {
  namespaced: true,

  state: () => ({
    number: Math.floor(Math.random() * 10),
    componentData: null,
    componentToken: "a900a06cc6b3e8036afb9eeb1bbf9783f0007698ed8f5cb1e373dc790e7be2e5",
    ismodalopen: false,
    modals: {
      isOpen: false,
      current: "Indicators",
      currentTitle: ""
    },
    symbolList: [],
    seriesColors: [],
    chart: null,
    symbolDataCache: {}
  }),
  getters: {
    getSeriesColors: state => {
      return state.seriesColors
    },
    getModalTitle: state => {
      return state.modals.currentTitle
    },
    getModalIsOpen: state => {
      return state.modals.isOpen
    },
    getComponentToken: state => {
      return state.componentToken
    },
    getCurrentModal: state => {
      return state.modals.current
    },
    getsymbolList: state => {
      return state.symbolList
    }
  },
  mutations: {
    SET_CHART_COLORS(state, colors) {
      state.seriesColors = colors;
    },
    SET_MODAL_ISOPEN(state, isOpen) {
      state.ismodalopen = isOpen;
      state.modals.isOpen = isOpen
    },
    SET_COMPONENT_DATA(state, componentData) {
      state.componentData = componentData
    },
    SET_CURRENT_MODAL(state, {
      modal,
      modalTitle
    }) {
      state.modals.currentTitle = modalTitle ? modalTitle : "Settings"
      state.modals.current = modal
    },
    ADD_SYMBOL_LIST(state, symbolObj) {
      let newSymbol = {
        symbolstring: symbolObj.symbolstring,
        label: symbolObj.label ? symbolObj.label : symbolObj.symbolstring,
        color: symbolObj.color ?
          symbolObj.color : state.seriesColors[state.symbolList.length]
      }
      state.symbolList.push(newSymbol)
    },
    DEL_SYMBOL_LIST(state, symbolObjIndex) {
      state.symbolList.splice(symbolObjIndex, 1)
    }
    //this.series.splice(index, 1)
  },
  actions: {
    async asyncGetComponentData({
      commit,
      getters
    }, symbol) {
      try {
        const token = getters.getComponentToken;
        const url = `//${rootState.ENV}.quotemedia.com/datatool/getEnhancedQuotes.json?symbols=${symbol}&afterhours=true&timezone=true&premarket=true&currencyInd=true&countryInd=true`;

        const getJSON = await axios.get(url, {
        headers: {
            'Datatool-Token': token
        }
        });
        commit("SET_COMPONENT_DATA", getJSON.data)
      } catch (e) {
        // console.log(e)
        return "INVALID"
      }
    }
  }
}
